import { COMBINED_REGIONS, REGION_EN_TO_FR } from "~/constants/regions"

/**
 * Lookup a state or province ISO code to its name.
 *
 * @param   {string} stateIsoCode The ISO code of the state or province.
 * @returns {string} The slug of the state or province.
 *
 * @example lookupIsoCodeToSlug('AB') // 'alberta'
 */
export const lookupIsoCodeToSlug = (stateIsoCode: keyof typeof COMBINED_REGIONS, locale: 'en' | 'fr') => {
    const slug = COMBINED_REGIONS[stateIsoCode]?.slug

    if (!slug) {
        return undefined
    }

    if (locale === 'fr') {
        return REGION_EN_TO_FR[slug] ?? slug
    }

    return slug
}
